import styled from "styled-components";
import colors from "../../../theme/colors";

interface ICrownIcon {
    style?: any;
}

const IconContainer = styled.span`
    display: flex;
    align-items: center;
`;

const CrownIcon: React.FC<ICrownIcon> = ({style}) => {
    return (
        <IconContainer style={style}>
            <svg width="15" height="12" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.90765 3.39226L0.233567 0.272495C0.167667 0.195612 0.0423551 0.254131 0.0590024 0.354014L0.986073 5.91644C0.99411 5.96466 1.03583 6 1.08471 6H8.91529C8.96417 6 9.00589 5.96466 9.01393 5.91644L9.941 0.354014C9.95764 0.254131 9.83233 0.195612 9.76643 0.272495L7.09235 3.39226C7.04734 3.44477 6.96391 3.43684 6.9296 3.3768L5.08682 0.151943C5.04843 0.0847611 4.95157 0.0847608 4.91318 0.151942L3.0704 3.3768C3.03609 3.43684 2.95266 3.44477 2.90765 3.39226Z" fill={colors.yellow}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M9 7.9C9 7.95523 8.95523 8 8.9 8H1.1C1.04477 8 1 7.95523 1 7.9V7.1C1 7.04477 1.04477 7 1.1 7H8.9C8.95523 7 9 7.04477 9 7.1V7.9Z" fill={colors.yellow}/>
            </svg>
        </IconContainer>
    )
}

export default CrownIcon;